import { createContext } from 'react';
import { CustomAlarmFormMode } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.model';
import { CustomAlarmDefinition } from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';

export interface CustomAlarmsFormContextProps {
    mode: CustomAlarmFormMode;
    customAlarmDefinition?: CustomAlarmDefinition;
    isFormLoading: boolean;
}

export const CustomAlarmsFormContext = createContext<CustomAlarmsFormContextProps | undefined>(undefined);
